/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Studyprograms_Study_Archaeological_Sciences28Inputs */

const en__field__enum_studyprograms_study_archaeological_sciences28 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Archaeological_Sciences28Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archaeological Sciences`)
};

const de__field__enum_studyprograms_study_archaeological_sciences28 = /** @type {(inputs: _Field__Enum_Studyprograms_Study_Archaeological_Sciences28Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archäologische Wissenschaften`)
};

/**
* | output |
* | --- |
* | "Archaeological Sciences" |
*
* @param {_Field__Enum_Studyprograms_Study_Archaeological_Sciences28Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_studyprograms_study_archaeological_sciences28 = /** @type {((inputs?: _Field__Enum_Studyprograms_Study_Archaeological_Sciences28Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Studyprograms_Study_Archaeological_Sciences28Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_studyprograms_study_archaeological_sciences28(inputs)
	return de__field__enum_studyprograms_study_archaeological_sciences28(inputs)
});
export { _field__enum_studyprograms_study_archaeological_sciences28 as "_field__enum_studyPrograms_STUDY_ARCHAEOLOGICAL_SCIENCES" }